'use client'
import * as React from 'react'
import { tw } from 'utils/classnames'
import { ChevronDownIcon } from 'primitives/icons'

import { useMenu } from './context'

interface MenuItemsProps {
  title: string
  showAll: string
}

export function MenuHead({ title, showAll }: MenuItemsProps) {
  const { allOpen, setAllOpen, mobileOpen, setMobileOpen } = useMenu()

  return (
    <div
      className={tw(
        'mb-4 flex min-w-72 flex-row items-center justify-between bg-[#EFEEF4] p-2 uppercase text-[#A0B2B8] md:flex-row md:bg-transparent md:p-0',
      )}
      tabIndex={0}
      onClick={() => setMobileOpen(open => !open)}
      data-testid="show-menu-mobile"
    >
      <span dangerouslySetInnerHTML={{ __html: title || '' }} />
      <button
        className="text-12 hidden uppercase outline-none md:block"
        onClick={() => setAllOpen(open => !open)}
        aria-expanded={allOpen ? 'true' : 'false'}
        data-state={allOpen ? 'open' : 'closed'}
        data-testid="show-all-desktop"
      >
        {showAll} <span className="inline-block w-1">{allOpen ? '-' : '+'}</span>
      </button>
      <ChevronDownIcon
        className={tw('transition-transform', mobileOpen && 'rotate-180', 'md:hidden')}
      />
    </div>
  )
}
